// Components, Layouts, Pages
import {
  CrmCommonPage,
  JobsCommonPage,
  LeadCommonPage,
  TaskCommonPage,
  UserCommonPage,
  VenueCommonPage,
  OrderCommonPage,
  QuotesCommonPage,
  TrucksCommonPage,
  ClientCommonPage,
  GlobalCommonPage,
  ReportsCommonPage,
  TrailerCommonPage,
  PackageCommonPage,
  InvoiceCommonPage,
  VendorsCommonPage,
  CouponsCommonPage,
  ScheduleCommonPage,
  SettingsCommonPage,
  CategoryCommonPage,
  UserFormCommonPage,
  VehiclesCommonPage,
  DashboardCommonPage,
  EquipmentCommonPage,
  InventoryCommonPage,
  EventTypeCommonPage,
  RoleFormCommonPage,
  VenueFormCommonPage,
  OrderFormCommonPage,
  ChecklistCommonPage,
  JobDetailCommonPage,
  QuarantineCommonPage,
  QuotesFormCommonPage,
  UserDetailCommonPage,
  ClientFormCommonPage,
  InventoriesCommonPage,
  PackageFormCommonPage,
  VenueDetailCommonPage,
  InvoiceFormCommonPage,
  ClientDetailCommonPage,
  QuotesDetailCommonPage,
  OrderDetailsCommonPage,
  PurchaseOrderCommonPage,
  InventoryFormCommonPage,
  RevenueReportCommonPage,
  DeliveryReportCommonPage,
  TaskCompletionCommonPage,
  VendorsDetailsCommonPage,
  RoleManagementCommonPage,
  InventoryDetailCommonPage,
  JobCostingReportCommonPage,
  QuarantineReportCommonPage,
  QuoteRevenueReportCommonPage,
  OrderRevenueReportCommonPage,
  CancellationReportCommonPage,
  ClientIncomeReportCommonPage,
  FeatureUtilizationCommonPage,
  ReportsForemanTaskCommonPage,
  DiscountUsageReportCommonPage,
  PurchaseOrderDetailsCommonPage,
  ReportsFinancialOrderCommonPage,
  ReportsInventoryUsageCommonPage,
  ReportsOverbookingItemCommonPage,
  ReportsMarketingRevenueCommonPage,
  GeographicRevenueReportCommonPage,
  ReportsSubrentalsReportCommonPage,
  ReportsTransactionSummaryCommonPage,
} from '~/pages/common';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
import { salesAdminRoute, salesAdminRouteAbsolute } from '../roleRoutes/salesAdmin';
// Styles, images, icons
import { icons } from '~/assets';

export const privateSalesAdminRoutes: IRouteModel[] = [
  // Dashboard
  {
    index: true,
    path: salesAdminRoute.base,
    component: DashboardCommonPage,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardUnactive,
    activeIcon: icons.menuIconDashboardActive,
  },

  // Global
  {
    path: salesAdminRouteAbsolute.global,
    component: GlobalCommonPage,
  },

  // CRM
  {
    path: salesAdminRouteAbsolute.crm,
    component: CrmCommonPage,
    name: MenuNameEnum.CRM,
    icon: icons.menuIconCrmUnactive,
    activeIcon: icons.menuIconCrmActive,
    children: [
      {
        path: salesAdminRouteAbsolute.leads,
        component: LeadCommonPage,
        name: MenuNameEnum.LEADS,
      },
      {
        path: salesAdminRouteAbsolute.clients,
        component: ClientCommonPage,
        name: MenuNameEnum.CLIENT,
      },
    ],
  },
  {
    path: salesAdminRouteAbsolute.createLead,
    component: ClientFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.leads}${salesAdminRoute.commonDetail}${salesAdminRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.leads}${salesAdminRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },
  {
    path: salesAdminRouteAbsolute.createClient,
    component: ClientFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.clients}${salesAdminRoute.commonDetail}${salesAdminRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.crm}${salesAdminRoute.clients}${salesAdminRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },

  // Schedule
  {
    path: salesAdminRouteAbsolute.schedule,
    component: ScheduleCommonPage,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleUnactive,
    activeIcon: icons.menuIconScheduleActive,
  },

  // Jobs
  {
    path: salesAdminRouteAbsolute.jobs,
    component: JobsCommonPage,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsUnactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.jobs}${salesAdminRoute.commonDetail}`,
    component: JobDetailCommonPage,
  },

  // Task
  {
    path: salesAdminRouteAbsolute.task,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTaskInActive,
    activeIcon: icons.menuIconTaskActive,
    component: TaskCommonPage,
  },

  // Communication
  // {
  //   path: salesAdminRouteAbsolute.communication,
  //   component: CommunicationCommonPage,
  //   name: MenuNameEnum.COMMUNICATION,
  //   icon: icons.menuIconCommunicationUnactive,
  //   activeIcon: icons.menuIconCommunicationActive,
  // },

  // Quotes
  {
    path: salesAdminRouteAbsolute.quotes,
    component: QuotesCommonPage,
    name: MenuNameEnum.QUOTES,
    icon: icons.menuIconQuotesUnactive,
    activeIcon: icons.menuIconQuotesActive,
  },
  {
    path: salesAdminRouteAbsolute.createQuotes,
    component: QuotesFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.quotes}${salesAdminRoute.commonDetail}${salesAdminRoute.commonEdit}`,
    component: QuotesFormCommonPage,
  },

  //  Order
  {
    path: salesAdminRouteAbsolute.order,
    component: OrderCommonPage,
    name: MenuNameEnum.ORDER,
    icon: icons.menuIconOrderInactive,
    activeIcon: icons.menuIconOrderActive,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.order}${salesAdminRoute.commonDetail}`,
    component: OrderDetailsCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.order}${salesAdminRoute.commonDetail}${salesAdminRoute.commonEdit}`,
    component: OrderFormCommonPage,
  },

  // Invoice
  {
    path: salesAdminRouteAbsolute.invoices,
    component: InvoiceCommonPage,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: salesAdminRouteAbsolute.createInvoice,
    component: InvoiceFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.invoice}${salesAdminRoute.commonDetail}${salesAdminRoute.commonEdit}`,
    component: InvoiceFormCommonPage,
  },

  // Inventories
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.quotes}${salesAdminRoute.commonDetail}`,
    component: QuotesDetailCommonPage,
  },
  {
    path: salesAdminRouteAbsolute.inventories,
    component: InventoriesCommonPage,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconInventoryInactive,
    activeIcon: icons.menuIconInventoryActive,
    children: [
      {
        path: salesAdminRouteAbsolute.inventory,
        component: InventoryCommonPage,
        name: MenuNameEnum.PRODUCT,
      },
      {
        path: salesAdminRouteAbsolute.package,
        component: PackageCommonPage,
        name: MenuNameEnum.PACKAGE,
      },
      {
        path: salesAdminRouteAbsolute.quarantine,
        component: QuarantineCommonPage,
        name: MenuNameEnum.QUARANTINE,
      },
    ],
  },
  {
    path: salesAdminRouteAbsolute.createInventory,
    component: InventoryFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.product}${salesAdminRoute.commonDetail}`,
    component: InventoryDetailCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.product}${salesAdminRoute.commonDetail}${salesAdminRoute.commonEdit}`,
    component: InventoryFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.package}${salesAdminRoute.commonDetail}${salesAdminRoute.commonEdit}`,
    component: PackageFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.inventory}${salesAdminRoute.package}${salesAdminRoute.commonDetail}${salesAdminRoute.commonClone}`,
    component: PackageFormCommonPage,
  },

  // Report
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}`,
    component: ReportsCommonPage,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportUnactive,
    activeIcon: icons.menuIconReportActive,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.overbookingItem}`,
    component: ReportsOverbookingItemCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.subrentalsReport}`,
    component: ReportsSubrentalsReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.clientIncomeReport}`,
    component: ClientIncomeReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.revenueReport}`,
    component: RevenueReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.geographicRevenueReport}`,
    component: GeographicRevenueReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.quoteRevenueReport}`,
    component: QuoteRevenueReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.orderRevenueReport}`,
    component: OrderRevenueReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.cancellationReport}`,
    component: CancellationReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.deliveryReport}`,
    component: DeliveryReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.taskCompletionReport}`,
    component: TaskCompletionCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.discountUsageReport}`,
    component: DiscountUsageReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.featureUtilizationReport}`,
    component: FeatureUtilizationCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.jobCostingReport}`,
    component: JobCostingReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.inventoryUsageReport}`,
    component: ReportsInventoryUsageCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.quarantineReport}`,
    component: QuarantineReportCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.foremanTaskReport}`,
    component: ReportsForemanTaskCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.marketingRevenueReport}`,
    component: ReportsMarketingRevenueCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.financialOrderReport}`,
    component: ReportsFinancialOrderCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.reports}${salesAdminRoute.transactionSummaryReport}`,
    component: ReportsTransactionSummaryCommonPage,
  },

  // Package
  {
    path: salesAdminRouteAbsolute.createPackage,
    component: PackageFormCommonPage,
  },

  {
    path: salesAdminRouteAbsolute.vehicles,
    component: VehiclesCommonPage,
    name: MenuNameEnum.VEHICLES,
    icon: icons.menuIconVehicleInactive,
    activeIcon: icons.menuIconVehicleActive,
    children: [
      {
        path: salesAdminRouteAbsolute.trucks,
        component: TrucksCommonPage,
        name: MenuNameEnum.TRUCKS,
        icon: icons.menuIconTruckInActive,
        activeIcon: icons.menuIconTruckActive,
      },
      {
        path: salesAdminRouteAbsolute.trailers,
        component: TrailerCommonPage,
        name: MenuNameEnum.TRAILERS,
        icon: icons.menuIconTrailerInActive,
        activeIcon: icons.menuIconTrailerActive,
      },
      {
        path: salesAdminRouteAbsolute.equipments,
        component: EquipmentCommonPage,
        name: MenuNameEnum.EQUIPMENTS,
        icon: icons.menuIconEquipmentInActive,
        activeIcon: icons.menuIconEquipmentActive,
      },
    ],
  },

  // Vendors
  {
    path: salesAdminRouteAbsolute.vendors,
    component: VendorsCommonPage,
    name: MenuNameEnum.VENDORS,
    icon: icons.menuIconVendorsInactive,
    activeIcon: icons.menuIconVendorsActive,
  },
  {
    path: salesAdminRouteAbsolute.detailVendor,
    component: VendorsDetailsCommonPage,
  },

  // Purchase Order
  {
    path: salesAdminRouteAbsolute.purchaseOrder,
    component: PurchaseOrderCommonPage,
    name: MenuNameEnum.PURCHASE_ORDER,
    icon: icons.menuIconPurchaseInactive,
    activeIcon: icons.menuIconPurchaseActive,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.purchaseOrder}${salesAdminRoute.commonDetail}`,
    component: PurchaseOrderDetailsCommonPage,
  },

  // Settings
  {
    path: salesAdminRouteAbsolute.settings,
    component: SettingsCommonPage,
    name: MenuNameEnum.SETTINGS,
    icon: icons.menuIconSettingUnactive,
    activeIcon: icons.menuIconSettingActive,
  },

  // User
  {
    path: salesAdminRouteAbsolute.users,
    component: UserCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.users}${salesAdminRoute.commonDetail}`,
    component: UserDetailCommonPage,
  },
  {
    path: salesAdminRouteAbsolute.createUser,
    component: UserFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.users}${salesAdminRoute.commonDetail}${salesAdminRoute.commonEdit}`,
    component: UserFormCommonPage,
  },

  // Venue
  {
    path: salesAdminRouteAbsolute.venue,
    component: VenueCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.venue}${salesAdminRoute.commonDetail}`,
    component: VenueDetailCommonPage,
  },
  {
    path: salesAdminRouteAbsolute.createVenue,
    component: VenueFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.venue}${salesAdminRoute.commonDetail}${salesAdminRoute.commonEdit}`,
    component: VenueFormCommonPage,
  },

  // Role Management
  {
    path: salesAdminRouteAbsolute.roleManagement,
    component: RoleManagementCommonPage,
  },
  {
    path: salesAdminRouteAbsolute.createRole,
    component: RoleFormCommonPage,
  },
  {
    path: `${salesAdminRoute.base}${salesAdminRoute.settings}${salesAdminRoute.roleManagement}${salesAdminRoute.commonDetail}${salesAdminRoute.commonEdit}`,
    component: RoleFormCommonPage,
  },

  // Coupon
  {
    path: salesAdminRouteAbsolute.coupon,
    component: CouponsCommonPage,
  },

  // Event Type
  {
    path: salesAdminRouteAbsolute.eventType,
    component: EventTypeCommonPage,
  },

  // Category
  {
    path: salesAdminRouteAbsolute.category,
    component: CategoryCommonPage,
  },

  // Checklist
  {
    path: salesAdminRouteAbsolute.checklist,
    component: ChecklistCommonPage,
  },
];
